<template>
  <div>
    <content-area :content="imprint"></content-area>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';

import contentArea from '@/components/content/content-area.vue';

export default {
  data() {
    return {
      imprint: []
    };
  },

  computed: {
    ...mapState({
      currentLanguage: 'currentLanguage'
    }),

    ...mapState('companyModule', {
      slug: 'slug'
    })
  },

  watch: {
    async slug() {
      this.imprint = await this.loadImprint(this.slug);
    },

    currentLanguage() {
      this.setHeroClaim([
        {
          languageKey: this.currentLanguage,
          translation: this.$t('imprint')
        }
      ]);
    }
  },

  async mounted() {
    this.setHeroClaim([
      {
        languageKey: this.currentLanguage,
        translation: this.$t('imprint')
      }
    ]);

    if (this.slug) {
      this.imprint = await this.loadImprint(this.slug);
    }
  },

  methods: {
    ...mapActions('companyModule', {
      loadImprint: 'loadImprint'
    }),

    ...mapMutations({
      setHeroClaim: 'setHeroClaim'
    })
  },

  components: {
    contentArea
  }
};
</script>
